import { Datagrid, List, ReferenceArrayInput, ReferenceField } from "react-admin";
import { TextField } from "react-admin";
import CustomDateField from "shared/components/fields/CustomDateField";
import CustomDateInput from "shared/components/inputs/CustomDateInput";
import { SiteResourcesEnum } from "shared/enums/resourceMappings";

export const GroupsSitesList = () => {
  const filters = [
    <ReferenceArrayInput key="site_id__in" source="site_id__in" reference={SiteResourcesEnum.Sites} />,
    <ReferenceArrayInput key="group_id__in" source="group_id__in" reference={SiteResourcesEnum.Groups} />,
    <CustomDateInput key="start_date" source="start_date" label="Start Date" />,
    <CustomDateInput key="end_date" source="end_date" label="End Date" />,
    <CustomDateInput key="start_date__gte" source="start_date__gte" label="Start Date >= " />,
    <CustomDateInput key="start_date__lte" source="start_date__lte" label="Start Date <= " />,
    <CustomDateInput key="end_date__gte" source="end_date__gte" label="End Date >= " />,
    <CustomDateInput key="end_date__lte" source="end_date__lte" label="End Date <= " />,
    <CustomDateInput key="end_date__gt_or_null" source="end_date__gt_or_null" label="End Date > or Null" />,
    <CustomDateInput key="end_date__gte_or_null" source="end_date__gte_or_null" label="End Date >= or Null" />,
  ];

  return (
    <List filters={filters}>
      <Datagrid bulkActionButtons={false}>
        <TextField source="id" />
        <ReferenceField source="group_id" reference={SiteResourcesEnum.Groups} />
        <ReferenceField source="site_id" reference={SiteResourcesEnum.Sites} />
        <CustomDateField source="start_date" showTime />
        <CustomDateField source="end_date" showTime />
      </Datagrid>
    </List>
  );
};
